import type { RouteObject } from 'react-router';

/**
 * `/profil` (P-08). No nav entry lives here — the account-menu link is wired
 * by the nav owner; this feature only has to exist for the router's glob
 * import of every feature's `routes.tsx` (see `app/router.tsx`) to pick it up.
 */
export const routes: RouteObject[] = [
  {
    path: '/profil',
    lazy: async () => ({ Component: (await import('./ProfilePage')).ProfilePage }),
  },
];
